export enum ORDER_STATUS {
	created = 'created',
	in_preparation = 'in_preparation',
	ready = 'ready',
	shipped = 'shipped',
	cancelled = 'cancelled',
	cancellation_in_progress = 'cancellation_in_progress',
	delivered = 'delivered',
	reserved = 'reserved',
	rejected = 'rejected',
	refunded = 'refunded',
	on_delivery = 'on_delivery',
	not_delivered = 'not_delivered',
	denied = 'denied',
	in_store = 'in_store',
	in_droppoint = 'in_droppoint',
	received = 'received',
	not_available = 'not_available',
	on_international_transit = 'on_international_transit',
}
